











import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import ProgressItem from '@/trials/views/components/ProgressItem.vue';

@Component({ components: { ProgressItem } })
export default class KCTraining extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private intervalMs: number = 1000 * 1;

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // 学習状態
    private get trainState(): number {
        return sessionModule.getTrained;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        if (this.trainState === SC.Flag.Process.TODO) {
            // フラグ更新(学習 実施中)
            sessionModule.SET_TRAINED(SC.Flag.Process.DOING);
            this.getTrainResult();
        }
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private async getTrainResult() {
        // 学習処理
        const ret = await sessionModule.training();

        if (!ret) {
            this.goBack();
            return;
        }

        // 演出のためプログレスバーを表示
        const self = this;
        setTimeout(() => {
            // フラグ更新（学習済）
            sessionModule.SET_TRAINED(SC.Flag.Process.DONE);

            // 学習結果への自動遷移
            sessionModule.SET_ROUTE_TRIALS(SC.Path.TRAIN_RESULT_MENU);
            self.$router.replace(sessionModule.getCurrentRouterViewTrials);
        }, this.intervalMs);
    }

    private goBack(): void {
        // フラグ更新（未学習）
        sessionModule.SET_TRAINED(SC.Flag.Process.TODO);

        // この画面が表示されている場合はひとつ前にもどる
        if (this.$route.path === SC.Path.TRAIN_KC_TRAINING) {
            this.$router.go(-1);
        }
    }
}
